var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0987F4",
    d: "M17.464 7.86a5.41 5.41 0 0 0-4.243-2.168C9.96 5.692 7.577 8.717 7.577 12c0 2.29 1.517 4 3.206 4q.236.001.467-.043c-1.132-.823-1.856-2.327-1.856-3.956c0-2.593 1.757-4.616 3.823-4.616c2.258 0 3.827 2.242 3.827 4.616a7.5 7.5 0 0 1-1.736 4.787a5.97 5.97 0 0 1-3.57 2.062s.112.008.262.008A6.857 6.857 0 0 0 17.464 7.86M16.423 12c0-2.288-1.518-3.998-3.206-3.998a2.4 2.4 0 0 0-.467.042c1.131.823 1.855 2.328 1.855 3.956c0 2.593-1.757 4.616-3.822 4.616c-2.26 0-3.828-2.242-3.828-4.616c.009-1.757.635-3.497 1.736-4.787a5.97 5.97 0 0 1 3.57-2.061s-.111-.009-.261-.009A6.857 6.857 0 0 0 6.535 16.14a5.4 5.4 0 0 0 4.243 2.169c3.262 0 5.644-3.026 5.644-6.309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRose);
export default __webpack_public_path__ + "static/media/rose.21472653135d30d27c36722a240dc831.svg";
export { ForwardRef as ReactComponent };